module.exports = __webpack_public_path__ + "static/media/gateway_configure.6450c74b.png";